<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Vendedores</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <k-table
          @crear="crear"
          @editar="editar"
          @eliminar="eliminar"
          :createButton="puede_crear_vendedor"
          :editButton="puede_editar_vendedor"
          :deleteButton="puede_eliminar_vendedor"
          :path="path"
          ref="listaVendedores"
          :columns="[
            {
              display: 'Código',
              value: 'codigo',
            },
            {
              display: 'Nombre/Descripción',
              value: 'descripcion',
            },
            {
              display: 'Identificación',
              value: 'numero_identificacion',
            },
            {
              display: 'Dirección',
              value: 'direccion',
            },
            {
              display: 'Teléfonos',
              value: 'telefonos',
            },
            {
              display: 'Correos',
              value: 'correos',
            },
            {
              display: 'Creador',
              value: 'creador.nombre',
            },
            {
              display: 'Creación',
              value: 'created_at',
            },
            {
              display: 'Modificador',
              value: 'modificador.nombre',
            },
            {
              display: 'Modificación',
              value: 'updated_at',
            }
          ]"
        ></k-table>
      </div>
    </div>
    <modal
      name="vendedor"
      height="auto"
      width="70%"
      scrollable
      adaptive
      resizable
      reset
    >
      <vendedor
        @cancelar="cancelar"
        v-model="selectedVendedor"
        @saved="vendedorSaved"
        ref="vendedor"
      ></vendedor>
    </modal>
  </div>
</template>

<script>
import Axios from "axios";
import Vendedor from "./Vendedor.vue";
export default {
  components: {
    Vendedor,
  },
  props: {
    puede_crear_vendedor: {
      type: Boolean,
      required: false,
    },
    puede_editar_vendedor: {
      type: Boolean,
      required: false,
    },
    puede_eliminar_vendedor: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    cancelar: function () {
      this.$modal.hide("vendedor");
    },
    crear: function () {
      this.selectedVendedor = {
        descripcion: "",
        direccion: "",
        telefonos: "",
        correos: "",
        id: "",
        numero_identificacion: "",
        _method: undefined,
        codigo: "",
      };
      this.$modal.show("vendedor");
    },
    vendedorSaved: function () {
      this.$refs.listaVendedores.loadRows();
      this.$modal.hide("vendedor");
    },
    editar: function (vendedor) {
      this.selectedVendedor = {
        descripcion: vendedor.descripcion,
        direccion: vendedor.direccion,
        telefonos: vendedor.telefonos,
        correos: vendedor.correos,
        id: vendedor.id,
        _method: "PUT",
        numero_identificacion: vendedor.numero_identificacion,
        codigo: vendedor.codigo,
      };
      this.$modal.show("vendedor");
    },
    eliminar: function (vendedor) {
      let estado = vendedor.estado;
      let accion = estado == "I" ? "re-activar" : "inactivar";
      swal({
        title: "¿Desea " + accion + " el vendedor seleccionado?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/logistica/vendedores/" + vendedor.id, {
              _method: "DELETE",
            })
            .then(() => {
              swal("Proceso realizado exitósamente.", "Realizado", "success");
              this.$refs.listaVendedores.loadRows();
            })
            .catch(() => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
  },
  data: function () {
    return {
      selectedVendedor: null,
      path: url + "/logistica/vendedores",
    };
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/vendedores/ListaVendedores.vue